// extracted by mini-css-extract-plugin
export default {"h2":"Users_h2__fj7Rd","content":"Users_content__1doqg","green":"Users_green__Z+u7K","red":"Users_red__+NzeY"};